// extracted by mini-css-extract-plugin
module.exports = {"wrap":"About_wrap__YPyhW","title":"About_title__3r4Wv","image":"About_image__2VaMp","body":"About_body__11nx9","link":"About_link__2ihpB"};